var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected),expression:"selected"}],staticClass:"tab-section",attrs:{"id":`scrollTarget-${_vm.name}`}},[_c('h2',{staticClass:"sectionTitle text-gray-darkest capitalize"},[_vm._v(_vm._s(_vm.name))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }